import React from 'react';
import forLayout from '../../use/useForLayout';

export default ({ children }) => {
  const { copiable, mainKey, shouldFix } = forLayout.useMainContainer();

  React.useEffect(() => {
    // 由于页面动态组装，内容区的 min-height 变得无法固定，所以自己计算一下比较稳妥
    const height = window.tmConfig.getContentHeight();
    const heightStyle = `calc(100vh - ${height}px)`;
    document.querySelector('.container-height').style['min-height'] = heightStyle;
    // document.querySelector('.container-height').style['margin-bottom'] = '16px';
  });

  return (
    <div
      key={`${mainKey}`}
      className={`container-height ${shouldFix ? 'height-fix' : ''} ${
        copiable ? '' : 'disable-copy'
      }`}
    >
      {children}
    </div>
  );
};
